<template>
  <v-container>
    <v-btn small fab color="white" router to="/dashboard">
      <v-icon medium color="red">close</v-icon>
    </v-btn>
    <h2>Lists of Human Rights Defenders Trained in various areas</h2>
    <v-divider></v-divider>
    <v-card flat>
      <v-layout row wrap class="grey lighten-4">
        <v-flex xs12 md4>
          <v-text-field
            class="pa-3"
            @keydown="inputText"
            v-model="search"
            label="Enter the name of HRD"
            prepend-icon="search"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-menu offset-y>
            <v-btn class="pa-3" flat slot="activator" color="teal">
              <v-icon left>expand_more</v-icon>
              <span>Area of Training</span>
            </v-btn>
            <v-list>
              <v-list-tile v-for="category in categories" :key="category.category">
                <v-list-tile-title @click="selectedCat(category.category)">{{ category.category }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
        <v-flex xs12 md4 class="pt-3">
          <v-tooltip top>
            <v-btn small flat @click="selected = '', search= ''" slot="activator">
              <v-icon left>clear</v-icon>
              <span>Reset</span>
            </v-btn>
            <span class="pt-3">Clear all Filters</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-card>
    <v-divider></v-divider>
    <v-card flat v-for="person in filteredParticipants" :key="person.id">
      <v-layout row wrap>
        <v-flex xs12 md4 class="white pa-1">
          <div class="pa-1">
            <h4 class="teal--text">{{person.p_name }}</h4>
            <div>
              <h4>Mobile No: {{person.p_phone}}</h4>
            </div>
            <div>
              <h5>Email: {{person.p_email }}</h5>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 md4 class="white pa-1">
          <div class="pa-1">
            <h4 class="teal--text">{{ person.p_org }}</h4>
            <div>{{person.area}} , {{person.county}}</div>
            <div v-for="(area,i) in person.theme" :key="area[0]">Theme: {{i+1}}. {{area}}</div>
          </div>
        </v-flex>
        <v-flex xs12 md4 class="white pa-1">
          <div class="pa-1">
            <h4 class="teal--text">Training Details</h4>
            <div class="pl-1">Attended {{person.category}} Training</div>
            <div class="pl-1">
              <h4>{{person.level}} level</h4>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-divider class="teal lighten-3"></v-divider>
    </v-card>
  </v-container>
</template>
<script>
import { db, auth, functions } from "@/fb";
export default {
  data() {
    return {
      categories: [],
      participants: [],
      panel: false,
      themes: [],
      select: false,
      selected: "",
      search: ""
    };
  },
  computed: {
    filteredParticipants() {
      if (this.selected != "") {
        return this.participants.filter(item => {
          return item.category
            .toLowerCase()
            .trim()
            .match(this.selected.toLowerCase().trim());
        });
      } else {
        return this.participants.filter(item => {
          return item.p_name
            .toLowerCase()
            .trim()
            .match(this.search.toLowerCase().trim());
        });
      }
    },
    participantsList() {
      return this.participants.filter(participant => {
        return participant.refno === this.trainingRef;
      });
    }
  },
  methods: {
    selectedCat(key) {
      this.selected = key;
      this.select = false;
    },
    inputText() {
      this.selected = "";
      this.select = false;
    }
  },
  created() {
    if (auth.currentUser == null) {
      this.$router.push({ name: "home" });
    }
    db.collection("participants").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === "added") {
          this.participants.push({
            ...change.doc.data(),
            id: change.doc.id
          });
        }
      });
    });

    db.collection("t_categories").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === "added") {
          this.categories.push({
            ...change.doc.data(),
            id: change.doc.id
          });
        }
      });
    });

    db.collection("r_categories").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === "added") {
          this.themes.push({
            ...change.doc.data(),
            id: change.doc.id
          });
        }
      });
    });
  }
};
</script>
